var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.6826,
    r: 20,
    fill: "#F9FCFF",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 23.1825L22.6583 20.6825L18.3333 18.1825V23.1825ZM27.9667 16.6575C28.075 17.0491 28.15 17.5741 28.2 18.2408C28.2583 18.9075 28.2833 19.4825 28.2833 19.9825L28.3333 20.6825C28.3333 22.5075 28.2 23.8491 27.9667 24.7075C27.7583 25.4575 27.275 25.9408 26.525 26.1491C26.1333 26.2575 25.4167 26.3325 24.3167 26.3825C23.2333 26.4408 22.2417 26.4658 21.325 26.4658L20 26.5158C16.5083 26.5158 14.3333 26.3825 13.475 26.1491C12.725 25.9408 12.2417 25.4575 12.0333 24.7075C11.925 24.3158 11.85 23.7908 11.8 23.1241C11.7417 22.4575 11.7167 21.8825 11.7167 21.3825L11.6667 20.6825C11.6667 18.8575 11.8 17.5158 12.0333 16.6575C12.2417 15.9075 12.725 15.4241 13.475 15.2158C13.8667 15.1075 14.5833 15.0325 15.6833 14.9825C16.7667 14.9241 17.7583 14.8991 18.675 14.8991L20 14.8491C23.4917 14.8491 25.6667 14.9825 26.525 15.2158C27.275 15.4241 27.7583 15.9075 27.9667 16.6575Z",
    fill: "#F9FCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.9b55cd9e78d51e89dc45047880f45271.svg";
export { ForwardRef as ReactComponent };